
  var _styles = {
  "slide-card-container": {
    "width": "9.36rem",
    "overflow": "hidden",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "city-card-item__main": {
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "width": "100%",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "city-card-item__main-bg": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "city-card-item__city-title-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.64rem"
  },
  "city-card-item__city-title-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.42667rem",
    "lineHeight": "0.64rem",
    "textAlign": "left"
  },
  "city-card-item__city-tags": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.42667rem",
    "marginTop": "0.06667rem"
  },
  "city-card-item__city-tag-item": {
    "borderRadius": "0.12rem",
    "backgroundColor": "rgba(0,0,0,0.4)",
    "height": "0.42667rem",
    "paddingTop": 0,
    "paddingRight": "0.10667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.10667rem",
    "marginTop": 0,
    "marginRight": "0.05333rem",
    "marginBottom": 0,
    "marginLeft": "0.05333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "flexDirection": "row"
  },
  "city-card-item__city-tag-text": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.42667rem",
    "textAlign": "center"
  },
  "city-card-item__city-desc": {
    "marginTop": "0.13333rem",
    "width": "6.4rem",
    "marginBottom": "0.22667rem"
  },
  "city-card-item__city-text": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem"
  },
  "city-card-item__mask": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "bottom": 0,
    "right": 0,
    "backgroundColor": "rgb(0,39,71)",
    "opacity": 0.6
  },
  "wish-city-flag": {
    "position": "absolute",
    "width": "100%",
    "top": 0,
    "left": "0%",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  }
};



  module.exports = _styles;
  